import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { ReactNode, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import TertiaryButton from '@components/buttons/TertiaryButton';
import styles from '@components/Question.module.css';
import Icon from '@components/text/Icon';
import useMyExpert from '@hooks/useMyExpert';
import { InitialConsultFields } from '@typing/Models';
import { IconName } from '@utils/iconUtils';

type Props = {
  field?: InitialConsultFields;
  handleEdit?: (field: InitialConsultFields) => () => void;
  icon?: IconName | null;
  selections: (string | null)[];
  titleKey?: string;
  titleValues?: Record<string, ReactNode>;
};

const InitialConsultQuestion = ({ field, handleEdit, icon, selections, titleKey, titleValues }: Props) => {
  const filteredSelections = useMemo(
    () => selections.filter(selection => selection !== null && selection !== ''),
    [selections]
  );
  const myExpert = useMyExpert();

  if (filteredSelections.length || myExpert) {
    return (
      <div className={styles.questionWrapper}>
        <IonGrid className="ion-no-padding">
          <IonRow className="ion-align-items-center">
            <IonCol className="ion-margin-end">
              <IonText className={styles.question}>
                {titleKey && <FormattedMessage id={titleKey} values={titleValues} />}
              </IonText>
            </IonCol>
            {handleEdit && field && myExpert && (
              <IonCol size="auto">
                <TertiaryButton icon="edit" onClick={handleEdit(field)} textKey="dictionary.edit" />
              </IonCol>
            )}
          </IonRow>
        </IonGrid>
        {filteredSelections.map(selection => (
          <div className={styles.selection} key={selection}>
            {icon && <Icon ariaLabelKey="accessibility.ariaLabels.questionIcon" className={styles.icon} icon={icon} />}
            <IonText className={styles.text}>{selection}</IonText>
          </div>
        ))}
      </div>
    );
  }
  return null;
};
export default InitialConsultQuestion;
